import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const HealthView = lazy(() => import('./HealthView'));

const route: FuseRouteItemType = {
	path: 'health',
	element: <HealthView />
};

export default route;
